import styled from 'styled-components';
import ReactSelect from 'react-select';

export const Line = styled.div`
  border: 1px solid #466afb;
  opacity: 0.06;
  margin-bottom: 24px;
`;

export const StyledBox = styled.div`
  background: rgba(70, 106, 251, 0.02);
  border: 1px solid #466afb;
  border-radius: 6px;
  padding: 14px;
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 400px;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const SliderValue = styled.div`
  font-family: 'Mark Pro';
  font-style: normal;
  font-weight: 500;
  text-align: center;
  font-size: 9px;
  color: #466afb;
  line-height: 100%;
  margin-top: 10px;
`;

export const OrderBox = styled.div`
  background: rgba(109, 206, 146, 0.03);
  border: 1px solid #6dce92;
  box-shadow: 0px 0px 24px rgba(41, 45, 50, 0.03);
  border-radius: 8px;
  padding: 32px;
  width: 100%;
  display: flex;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: no-wrap;

  @media (max-width: 768px) {
    flex-wrap: wrap;
  }
`;

export const OrderTitle = styled.div`
  font-family: 'Mark Pro';
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 100%;
  margin-right: 12px;
  color: #292d32;
`;

export const OrderValue = styled.div`
  font-family: 'Mark Pro';
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  color: #292d32;
  opacity: 0.5;
  line-height: 100%;
`;

export const UpgradePlan = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px 24px;
  gap: 10px;
  background: #ffffff;
  border: 1px solid #6dce92;
  border-radius: 18px;
`;
export const UpgradeIcon = styled.div`
  height: 16.67px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 16.67px;
  margin-right: 11px;
  border-radius: 5px;
  border: 1.5px solid #6dce92;
`;

export const Input = styled.input`
  width: 100%;
  border-radius: 6px;
  padding: 11.9px 15px;
  border: 2px solid rgba(41, 45, 50, 0.25);
  :focus {
    outline: none !important;
    border: 2px solid #466afb;
  }
  &[type='date'] {
    padding: 10.9px 15px;
  }
`;

export const Select = styled(ReactSelect)`
  & .react-select__value-container {
    padding: 8.7px 16px;
  }
`;
